import { ExclamationTriangleIcon } from "@heroicons/react/20/solid";

/**
 * Amber/yellow informational alert strip. Mirrors AlertRed's structure but
 * uses the signal-amber palette. Used for non-blocking warnings (e.g. soft
 * availability guards on the service form).
 *
 * @param {ReactNode} message - Text or JSX content (links are safe here)
 */
const AlertYellow = ({ message }) => {
  return (
    <div className="rounded-card bg-signal-amber-50 border border-signal-amber-100 border-l-4 border-l-signal-amber-500 p-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <ExclamationTriangleIcon
            aria-hidden="true"
            className="h-5 w-5 text-signal-amber-500"
          />
        </div>
        <div className="ml-3 text-sm text-signal-amber-600">
          <p>{message}</p>
        </div>
      </div>
    </div>
  );
};

export default AlertYellow;
